var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlatColorIconsGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7142 10.8815H21.8752V10.8366H12.5002V15.1635H18.3871C17.5283 17.6823 15.2205 19.4904 12.5002 19.4904C9.0486 19.4904 6.25016 16.5844 6.25016 13C6.25016 9.41573 9.0486 6.50966 12.5002 6.50966C14.0934 6.50966 15.5429 7.13382 16.6465 8.15335L19.5929 5.09368C17.7325 3.29314 15.2439 2.18274 12.5002 2.18274C6.74756 2.18274 2.0835 7.02619 2.0835 13C2.0835 18.9739 6.74756 23.8174 12.5002 23.8174C18.2528 23.8174 22.9168 18.9739 22.9168 13C22.9168 12.2747 22.845 11.5668 22.7142 10.8815Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.28467 7.96513L6.70706 10.5716C7.63311 8.19067 9.87581 6.50966 12.5003 6.50966C14.0935 6.50966 15.543 7.13382 16.6466 8.15335L19.593 5.09368C17.7326 3.29314 15.244 2.18274 12.5003 2.18274C8.49925 2.18274 5.02946 4.52847 3.28467 7.96513Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 23.8173C15.1906 23.8173 17.6354 22.748 19.4839 21.0091L16.2599 18.176C15.1789 19.0297 13.8581 19.4915 12.5 19.4903C9.79062 19.4903 7.4901 17.6963 6.62344 15.1926L3.22656 17.9105C4.95052 21.4137 8.45156 23.8173 12.5 23.8173Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7141 10.8814H21.875V10.8365H12.5V15.1635H18.387C17.9761 16.3623 17.2361 17.4098 16.2583 18.1766L16.2599 18.1755L19.4839 21.0086C19.2557 21.2239 22.9167 18.4087 22.9167 13C22.9167 12.2747 22.8448 11.5667 22.7141 10.8814Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatColorIconsGoogle);
export default __webpack_public_path__ + "static/media/flat-color-icons_google.ba4cc82cbb0720e150b6b075b2e5bb58.svg";
export { ForwardRef as ReactComponent };